import React from 'react'
import { compose } from 'redux'
import { prismicRichTextAsHTML } from 'prismic-utils'
import { withInjectParams } from '../../utils/InjectParams'
import renderEmbedHtml from '../../../lib/embedHtml'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import BaseRichText from 'constructicon/rich-text'

const RichText = ({
  classNames,
  children,
  injectParams,
  styles,
  ...props
}) => {
  const html = typeof children === 'object'
    ? prismicRichTextAsHTML(children.map(serializeElement))
    : children

  return (
    <BaseRichText styles={styles.root} {...props}>
      {injectParams(html)}
    </BaseRichText>
  )
}

const serializeElement = item => {
  if (item.type === 'embed' && item.oembed) {
    return {
      ...item,
      oembed: {
        ...item.oembed,
        html: renderEmbedHtml(item.oembed)
      }
    }
  }

  return item
}

export default compose(
  withInjectParams,
  withStyles(styles)
)(RichText)
